import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Chart from '../member/Chart';

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: '100%',
			border: '1px solid #979797',
			padding: '24px 20px 20px 20px'
		},
		content: {
			textAlign: 'left',
			padding: 0
		},
		cardTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 600,
			letterSpacing: 0,
		},
		barDiv: {
			marginTop: 35
		},
		percentageText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 24,
			fontWeight: 700,
			letterSpacing: 0,
			marginTop: 35,
		},
		barTitleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 400,
			letterSpacing: 0,
			marginTop: 35,
		}
	}
);

function makeBarOptions(value, color) {
	return {
		chart: {
			type: 'bar',
			height: 30,
			align: 'left',
			marginLeft: 0,
		marginRight: 0,
		spacingLeft: 0,
		spacingRight: 0
		},
		title: {
			text: null
		},
		legend: {
		enabled: false
		},
		tooltip: {
		enabled: false
		},
		credits: {
		enabled: false
		},  
		xAxis: {
			visible: false
		},
		yAxis: {
			visible: false
		},
		plotOptions: {
			series: {
				stacking: 'normal',
				borderColor: null,
				pointWidth: 20
			}
		},
		series: [{
			color: '#E9E9E9',
			data: [100 - value]
		}, {
			color: color,
			data: [value]
		}]
	};
}

const HorizontalBarCard = ( {cardTitle, bars} ) => {
	const classes = useStyles();

	return (

		<Card className={classes.root}>
			<CardContent className={classes.content}>
				<Typography className={classes.cardTitleText}>
					{cardTitle}
				</Typography>
				{bars.map((bar) => (
						<React.Fragment key={bar.title}>
							<div className={classes.barDiv}>
								<span className={classes.percentageText}>{bar.value}% </span> <span className={classes.barTitleText}>{bar.title}</span>
							</div>
							<Chart options={makeBarOptions(bar.value,bar.color)}/>
						</React.Fragment>
					))
				}	
        	</CardContent>
		</Card>
	)
}

export default HorizontalBarCard;